import { useState } from 'react';

import { useTheme } from '@emotion/react';
import { Card, Grid, Modal, useMediaQuery } from '@mui/material';
// ----------------------------------
// ----------------------------------
import LoginModal from 'pages/login-modal';

export default function KakaoLoginModal({ showModal, setShowModal }) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const [showLoginModal, setShowLoginModal] = useState(false);

  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: isMobile ? '105%' : '28%',
    maxHeight: '90vh',
    overflowY: 'auto',
    backgroundColor: 'transparent',
    border: 'none',
    boxShadow: 24,
    p: 0,
    scrollbarWidth: 'thin', // Firefox
    '&::-webkit-scrollbar': {
      width: '0.4em',
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: 'transparent', // Hide scrollbar thumb
    },
  };

  const handleClick = () => {
    handleClose();
    setShowLoginModal(true);
  };

  const handleClose = () => {
    setShowModal(false);
  };

  return (
    <>
      <LoginModal open={showLoginModal} setShowLoginModal={setShowLoginModal} />

      <Modal
        open={showModal}
        onClose={handleClose}
        disableEnforceFocus={true}
        disableBackdropClick={false} // Disable closing when clicking on the backdrop
        disableEscapeKeyDown={true}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        style={{ backdropFilter: 'blur(5px)', backgroundColor: 'transparent' }}
      >
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Card sx={style}></Card>
          </Grid>
        </Grid>
      </Modal>
    </>
  );
}

// 버튼

{
  /* <Grid item width={"100%"}>
                      <Button
                        // type="submit"
                        variant="contained"
                        size="small"
                        sx={{
                          fontSize: 15.5,
                          fontWeight: 500,
                          borderRadius: 2,
                          minWidth: "100%",
                          width: "100%",
                          borderRadius: 2,
                          backgroundColor: "primary.naver",
                          "&:hover": {
                            backgroundColor: "primary.naver",
                          },
                        }}
                      >
                        <img
                          src={naver}
                          style={{
                            width: "20px",
                            height: "20px",
                            marginRight: "8px",
                          }}
                        />
                        네이버 로그인
                      </Button>
                    </Grid> */
}
